var render = function render(){
  var _vm$currentStep, _vm$currentStep2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('help-bubble', {
    attrs: {
      "shown": !_vm.shown && _vm.hasSteps
    },
    on: {
      "click": _vm.forceStart
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showEnablePopup,
      expression: "showEnablePopup"
    }],
    staticClass: "absolute flex items-center justify-center h-full w-full"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "relative flex flex-col bg-white w-1/3 h-1/3 justify-evenly rounded-xl items-center",
    staticStyle: {
      "z-index": "49"
    }
  }, [_c('div', {
    staticClass: "absolute top-0 self-end mt-2 transform scale-50",
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_c('close-button')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-2 justify-center items-center"
  }, [_c('h1', {
    staticClass: "text-xl font-medium mb-1"
  }, [_vm._v("Bienvenue sur Neopass")]), _vm._v(" "), false ? _c('p', {
    staticClass: "text-base-0 text-gray-600 w-3/4 text-center"
  }, [_vm._v("Pour faciliter l’utilisation de votre carnet de parcours et de compétences, nous vous proposons d’activer le bouton “je valide” ci-dessous. Vous serez ainsi guidé étape par étape dans la création de votre carnet.")]) : _c('p', {
    staticClass: "text-base-0 text-gray-600 w-3/4 text-center"
  }, [_vm._v("\n                  Cliquer sur “je valide” pour être guidé(e).\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row w-full justify-center gap-4 h-8 mb-2"
  }, [_c('action-button', {
    staticClass: "text-2sm",
    attrs: {
      "libelle": "Activer plus tard",
      "borderColor": "border-indigo-400",
      "textColor": "text-indigo-600",
      "bgColor": "bg-indigo-300",
      "bgColorSquare": "bg-indigo-300",
      "iconColor": "text-indigo-600",
      "uppercase": false,
      "right": false,
      "responsive": false
    },
    on: {
      "clickAction": function ($event) {
        _vm.showEnablePopup = false;
      }
    }
  }), _vm._v(" "), _c('action-button', {
    staticClass: "text-2sm",
    attrs: {
      "libelle": "Je valide",
      "borderColor": "border-transparent",
      "textColor": "text-white",
      "bgColor": "bg-indigo-600",
      "bgColorSquare": "bg-transparent",
      "iconColor": "text-white",
      "uppercase": false,
      "right": true,
      "responsive": false
    },
    on: {
      "clickAction": _vm.enable
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shown,
      expression: "shown"
    }],
    staticClass: "absolute h-full w-full"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    ref: "bubble",
    staticClass: "absolute flex flex-col justify-between items-center",
    attrs: {
      "id": "onboarding"
    }
  }, [_c('div', {
    staticClass: "absolute top-0 self-end mt-2 transform scale-75",
    on: {
      "click": function ($event) {
        return _vm.finish();
      }
    }
  }, [_c('close-button')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-8 justify-center items-center h-7/10"
  }, [_c('h1', {
    staticClass: "text-xl font-medium mb-4"
  }, [_vm._v(_vm._s((_vm$currentStep = _vm.currentStep) === null || _vm$currentStep === void 0 ? void 0 : _vm$currentStep.title))]), _vm._v(" "), _c('p', {
    staticClass: "onboarding-content overflow-auto px-4 h-6/10"
  }, [_vm._v(_vm._s((_vm$currentStep2 = _vm.currentStep) === null || _vm$currentStep2 === void 0 ? void 0 : _vm$currentStep2.content_falc))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row w-full justify-center gap-4 h-8 mb-8"
  }, [_vm.currentStepIdx > 0 ? _c('action-button', {
    staticClass: "text-2sm",
    attrs: {
      "libelle": "Précedent",
      "borderColor": "border-indigo-400",
      "textColor": "text-indigo-600",
      "bgColor": "bg-indigo-300",
      "bgColorSquare": "bg-indigo-300",
      "iconColor": "text-indigo-600",
      "uppercase": false,
      "right": false,
      "responsive": false
    },
    on: {
      "clickAction": function ($event) {
        return _vm.previous();
      }
    }
  }) : _c('action-button', {
    staticClass: "text-2sm",
    attrs: {
      "libelle": "Ignorer",
      "borderColor": "border-indigo-400",
      "textColor": "text-indigo-600",
      "bgColor": "bg-indigo-300",
      "bgColorSquare": "bg-indigo-300",
      "iconColor": "text-indigo-600",
      "uppercase": false,
      "right": false,
      "responsive": false
    },
    on: {
      "clickAction": function ($event) {
        return _vm.finish();
      }
    }
  }), _vm._v(" "), _c('action-button', {
    staticClass: "text-2sm w-22",
    attrs: {
      "libelle": _vm.currentStepIdx === _vm.filteredSteps.length - 1 ? 'Fermer' : 'Suivant',
      "borderColor": "border-transparent",
      "textColor": "text-white",
      "bgColor": "bg-indigo-600",
      "bgColorSquare": "bg-transparent",
      "iconColor": "text-white",
      "uppercase": false,
      "icon": _vm.currentStepIdx !== _vm.filteredSteps.length - 1 ? 'arrow-right_1' : null,
      "right": true,
      "responsive": false
    },
    on: {
      "clickAction": function ($event) {
        return _vm.next();
      }
    }
  })], 1), _vm._v(" "), _vm.currentStepIdx === _vm.filteredSteps.length - 1 ? _c('div', {
    staticClass: "absolute transform scale-75",
    style: `left: 0; top: ${this.height - 35}px;`
  }, [_c('checkbox-indigo', {
    attrs: {
      "libelle": "Ne plus afficher",
      "value": _vm.stopShowing
    },
    on: {
      "input": function (newValue) {
        _vm.stopShowing = newValue;
      }
    }
  })], 1) : _vm._e()])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "absolute",
    attrs: {
      "id": "onboarding-noscroll-2"
    }
  }, [_c('div', {
    staticClass: "absolute",
    attrs: {
      "id": "onboarding-highlight"
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "absolute",
    attrs: {
      "id": "onboarding-noscroll"
    }
  }, [_c('div', {
    staticClass: "absolute",
    attrs: {
      "id": "onboarding-highlight"
    }
  })]);

}]

export { render, staticRenderFns }